<template>
  <div>
    <!-- TRACKING EVENT PROMPT -->
    <shipblu-prompt
      class="tracking-modal"
      @close="closeModal()"
      @cancel="closeModal()"
      :active.sync="addTrackingEventModal"
      :title="$t('Add Tracking Event')"
      :buttons-hidden="true"
    >
      <div>
        <p class="font-medium text-gray leading-tight mb-1">{{ $t('Tracking Event') }}</p>
        <v-select class="w-full" name="tracking" v-model="status" :placeholder="$t('Tracking Event')" v-validate="'required'" label="name" :options="common.defineOrderType(orderData) === 'delivery-orders' ? trackingEventsDelivery : common.defineOrderType(orderData) === 'cash-collections' ? trackingEventsCash : trackingEventsReturns"/>
        <span class="text-danger text-sm" v-show="errors.has('tracking')">{{ errors.first('tracking') }}</span>
      </div>
      <div v-if="status && (status.value === 'in_transit' || status.value === 'collected')" class="mt-4">
        <p class="font-medium text-gray leading-tight mb-1">{{ $t('Warehouse') }}</p>
        <v-select class="w-full" name="warehouse" v-model="warehouse" :placeholder="$t('Warehouse')" v-validate="'required'" label="name" :options="warehouses"/>
        <span class="text-danger text-sm" v-show="errors.has('warehouse')">{{ errors.first('warehouse') }}</span>
      </div>
      <div v-if="status && (status.value === 'return_attempted' || status.value === 'delivery_attempted' || status.value === 'collection_attempted')" class="mt-4">
        <p class="text-lg font-medium">{{ common.defineOrderType(orderData) === 'cash-collections' ? $t('FAILED COLLECT') : $t('FAILED DELIVERY') }} </p>
        <div class="px-2">
          <p class="my-1 font-medium text-darkgray">{{ $t(failedDeliveryQuestion) }}:</p>
          <ul class="centerx">
            <li class="text-sm text-black" v-for="choose in (trackings.filter(item => item.status === 'delivery_attempted')).length === 2 ? failedDeliveryAnswersOptions.filter(item => item.text !== 'Customer rescheduled' && item.text !== 'Customer request to change address') : failedDeliveryAnswersOptions" :key="choose.index">
              <vs-radio name="reason" v-validate="'required'" v-model="answer" :vs-value="choose.value">{{$t(choose.text)}}</vs-radio>
            </li>
          </ul>
          <span class="text-danger text-sm" v-show="errors.has('reason')">{{ errors.first('reason') }}</span>
        </div>
      </div>
      <div class="mt-3" v-if="openCamera() && localStorage.getItem('multipleWarehouses') === 'true' && $store.state.AppActiveUser.userRole === 'head-of-fleet'">
        <p class="text-center my-2 flex justify-between">
          <span>{{ $t('Scan order packages') }}</span>
          <span>{{ qrScanned.length + '/' + smsConfirmationCodes.length }}</span>
        </p>
        <CameraCodeScanner @scan="onScan"></CameraCodeScanner>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-7">
        <vs-button @click="closeModal()" class="text-grey-dark" color="lightgray">{{$t('Cancel')}}</vs-button>
        <vs-button @click="buttonClicked" :disabled="openCamera()">{{$t('Add')}}</vs-button>
      </div>
    </shipblu-prompt>
  </div>
</template>

<script>
import { CameraCodeScanner } from 'vue-barcode-qrcode-scanner'
import i18nData from '../../../i18n/i18nData'
import ShipbluPrompt from '@/layouts/components/ShipBluPrompt.vue'
import vSelect from 'vue-select'
import common from '../../../assets/utils/common'
import { sendRequest } from '../../../http/axios/requestHelper'

export default {
  props: ['addTrackingEventModal', 'orderData', 'warehouses', 'trackings'],
  data () {
    return {
      common,
      localStorage,
      qrScanned: [],
      trackingEventsDelivery: [
        {
          name: 'Pickup Requested',
          value: 'pickup_requested'
        },
        {
          name: 'Picked Up',
          value: 'picked_up'
        },
        {
          name: 'In Transit',
          value: 'in_transit'
        },
        {
          name: 'Out For Delivery',
          value: 'out_for_delivery'
        },
        {
          name: 'Delivery Attempted',
          value: 'delivery_attempted'
        },
        {
          name: 'Return To Origin',
          value: 'return_to_origin'
        },
        {
          name: 'Cancelled',
          value: 'cancelled'
        }
      ],
      trackingEventsReturns: [
        {
          name: 'Return Requested',
          value: 'return_requested'
        },
        {
          name: 'Picked Up',
          value: 'picked_up'
        },
        {
          name: 'In Transit',
          value: 'in_transit'
        },
        {
          name: 'Out For Return',
          value: 'out_for_return'
        },
        {
          name: 'Return Attempted',
          value: 'return_attempted'
        },
        {
          name: 'Returned',
          value: 'returned'
        },
        {
          name: 'Cancelled',
          value: 'cancelled'
        }
      ],
      trackingEventsCash: [
        {
          name: 'Collection Requested',
          value: 'collection_requested'
        },
        {
          name: 'Failed',
          value: 'failed'
        },
        {
          name: 'Collection Attempted',
          value: 'collection_attempted'
        },
        {
          name: 'Out For Collection',
          value: 'out_for_collection'
        },
        {
          name: 'Collected',
          value: 'collected'
        },
        {
          name: 'Cancelled',
          value: 'cancelled'
        }
      ],
      failedDeliveryAnswersOptions: [
        {
          text: 'Customer\'s phone is turned off',
          value: 'Customer\'s phone is turned off'
        },
        {
          text: 'Shipment doesn\'t follow the packaging guidelines',
          value: 'Shipment doesn\'t follow the packaging guidelines'
        },
        {
          text: 'Wrong address provided',
          value: 'Wrong address provided'
        },
        {
          text: 'Address not completed',
          value: 'Address not completed'
        },
        {
          text: 'No one at home',
          value: 'No one at home'
        },
        {
          text: 'Out Of Zone',
          value: 'Out Of Zone'
        },
        {
          text: 'Customer rescheduled',
          value: 'Customer rescheduled'
        },
        {
          text: 'Customer request to change address',
          value: 'Customer request to change address'
        },
        {
          text: 'Customer refused to accept delivery',
          value: 'Customer refused to accept delivery'
        },
        {
          text: 'Customer didn\'t have Money',
          value: 'Customer didn\'t have Money'
        },
        {
          text: 'Customer evade to receive',
          value: 'Customer evade to receive'
        },
        {
          text: 'Customer is not answering our calls',
          value: 'Customer is not answering our calls'
        },
        {
          text: 'Packaging does not follow ShipBlu guidelines',
          value: 'Packaging does not follow ShipBlu guidelines'
        },
        {
          text: 'Customer wants to open the package',
          value: 'Customer wants to open the package'
        }
      ],
      failedDeliveryQuestion: 'Choose reason for failed delivery',
      answer: '',
      status: '',
      smsConfirmationCodes: [],
      warehouse: '',
      multipleWarehouses: localStorage.getItem('multipleWarehouses'),
      userInfo: {}
    }
  },
  watch: {
    'status' (val) {
      if (val !== 'delivered') {
        this.qrScanned = []
      }
    },
    addTrackingEventModal (val) {
      if (val && this.orderData) {
        if (this.orderData.rto_requested) {
          this.trackingEventsDelivery.push({
            name: 'Returned',
            value: 'returned'
          })
        }
        if (this.orderData.fulfillment_provider_metadata) {
          if (this.orderData.tracking_number[0] === '1' || (this.orderData.tracking_number[0] === '3' && this.orderData.tracking_number[1] === '1')) {
            this.trackingEventsDelivery.shift()
          }
          if (this.orderData.tracking_number[0] === '2' || (this.orderData.tracking_number[0] === '3' && this.orderData.tracking_number[1] === '2')) {
            this.trackingEventsReturns.shift()
          }
        }
        if (this.orderData.packages) {
          this.orderData.packages.forEach(item => {
            if (!this.smsConfirmationCodes.includes(item.sms_confirmation_code)) {
              this.smsConfirmationCodes.push(item.sms_confirmation_code)
            }
          })
        }
      }
      if ((Number(this.orderData.cash_amount) > 0 && this.trackingEventsDelivery.filter(item => item.name === 'Delivered').length === 0) || (localStorage.getItem('multipleWarehouses') === 'true' && this.$store.state.AppActiveUser.userRole === 'head-of-fleet')) {
        this.trackingEventsDelivery.push({
          name: 'Delivered',
          value: 'delivered'
        })
      } else if (Number(this.orderData.cash_amount) === 0 && this.trackingEventsDelivery.filter(item => item.name === 'Delivered').length > 0) {
        this.trackingEventsDelivery.forEach((item, index) => {
          if (item.name === 'Delivered') this.trackingEventsDelivery.splice(index, 1)
        })
      }
    }
  },
  methods: {
    confirmCashCollected () {
      const transaction = {
        amount: this.orderData.cash_amount ? Number(this.orderData.cash_amount) : Number(this.orderData.amount),
        type: 'deposit',
        by: this.userInfo.name,
        reference_number: `${this.orderData.customer.address.zone.city.governorate.name} | ${this.orderData.tracking_number} | ${new Date().toISOString().slice(0, 10)}`
      }
      if (this.status.value === 'delivered') {
        this.warehouse = this.orderData.outbound_warehouse.id
      } else {
        this.warehouse = this.warehouse.id
      }
      sendRequest(true, false, this, `api/v1/accounting/khazna/${this.warehouse}/transactions/`, 'post', transaction, true,
        () => {
          this.addTracking()
        }
      )
    },
    removeRTO () {
      sendRequest(true, false, this, `api/v1/${this.$route.params.type}/${this.$route.params.orderID}/`, 'patch', { rto_requested: false}, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Delivery Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
            position: 'top-center'
          })
          this.trackingActive = false
          this.$emit('loadOrder')
        })
    },
    closeModal () {
      this.$validator.pause()
      this.$emit('addTrackingEventModal', false)
      this.answer = ''
      this.status = ''
      this.warehouse = ''
      this.qrScanned = []
    },
    openCamera () {
      if (this.status && this.status.value === 'delivered' && Number(this.orderData.cash_amount) === 0 && this.smsConfirmationCodes.length !== this.qrScanned.length) {
        return true
      } else {
        return false
      }
    },
    onScan ({ result }) {
      const scannedCode = result.split('OTQ: ')[1]
      const notify = (type, title, text) => {
        this.$vs.notify({
          color: type,
          title,
          text,
          position: 'top-center'
        })
      }
      if (!this.smsConfirmationCodes.includes(scannedCode)) {
        notify('danger', i18nData[this.$i18n.locale]['Failed'], i18nData[this.$i18n.locale]['Invalid QR Code'])
        return
      }
      if (this.qrScanned.includes(scannedCode)) {
        notify('danger', i18nData[this.$i18n.locale]['Failed'], i18nData[this.$i18n.locale]['Already Scanned'])
        return
      }
      this.qrScanned.push(scannedCode)
      notify('success', i18nData[this.$i18n.locale]['Success'], i18nData[this.$i18n.locale]['Scanned Success'])
    },
    buttonClicked () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.orderData.is_paid === false && this.status.value === 'delivered' && parseInt(this.orderData.cash_amount) > 0) || (this.status.value === 'collected' && parseInt(this.orderData.amount) > 0)) {
            this.confirmCashCollected()
          } else {
            this.addTracking()
          }
        }
      })
    },
    addTracking (statusReturnRequest) {
      let url = ''
      const trackings = []
      if (common.defineOrderType(this.orderData) === 'cash-collections') {
        url = 'api/v1/tracking/cash-collections/'
        trackings.push({
          cash_collection_request: this.$route.query.order,
          status: this.status.value
        })
      } else {
        url = 'api/v1/tracking/'
        trackings.push(
          {
            order: this.$route.query.order,
            packages: this.orderData.packages.map(item => item.package.id),
            status: statusReturnRequest ? statusReturnRequest : this.status.value
          }
        )
      }
      if (this.status.value === 'return_attempted' || this.status.value === 'delivery_attempted' || this.status.value === 'collection_attempted') {
        trackings[0].comment = this.answer
      }
      if (this.status.value === 'in_transit') {
        trackings[0].current_warehouse = this.warehouse.id
      }
      sendRequest(true, false, this, url, 'post', trackings, true,
        () => {
          this.closeModal()
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
            position: 'top-center'
          })
          this.$emit('loadOrder', 'trackingCardLoading')
        }
      )
    }
  },
  components: {
    CameraCodeScanner,
    vSelect,
    ShipbluPrompt
  },
  created () {
    this.userInfo = localStorage.getItem('idTokenPayload') ? JSON.parse(localStorage.getItem('idTokenPayload')) : {}
    if (this.$store.state.AppActiveUser.userRole === 'head-of-fleet' && localStorage.getItem('multipleWarehouses') === 'true') {
      this.trackingEventsReturns.push({
        name: 'Lost',
        value: 'lost'
      },
      {
        name: 'Damaged',
        value: 'damaged'
      })
      this.trackingEventsDelivery.push({
        name: 'Lost',
        value: 'lost'
      },
      {
        name: 'Damaged',
        value: 'damaged'
      })
    }
  }
}
</script>

<style lang="scss">
div.tracking-modal {
  .vs-dialog{
    max-width: 450px !important;
  }
  .vs-dialog {
    .vs-dialog-text {
      padding-top: 0px;
    }
  }
}
</style>